/**
 * Tela de status do ambiente.
 *
 * É o que responde, sem ambiguidade, se o `docker compose up` funcionou: mostra
 * cada dependência com o resultado da sonda `/ready` do backend. As telas de
 * produto (superadmin, admin e passaporte) entram nas etapas 3, 6 e 8.
 */

import { Logo } from "../ds";
import { useHealth, useReadiness } from "../api/health";

const DEPENDENCY_LABELS: Record<string, string> = {
  database: "PostgreSQL",
  redis: "Redis",
  storage: "MinIO (S3)",
};

export default function StatusPage() {
  const health = useHealth();
  const readiness = useReadiness();

  const checks = readiness.data?.checks ?? {};
  const dependencyNames = Object.keys(checks);

  return (
    <div className="shell">
      <div className="brand">
        <Logo tamanho={32} />
        <b>Aletia</b>
        <span>Armaturen · Valve Passport</span>
      </div>

      <div className="card">
        <h1>Plataforma no ar</h1>
        <p className="sub">
          Fase 1 — Valve Passport. Ambiente de desenvolvimento provisionado por Docker Compose.
        </p>

        <div className="sect">Serviços</div>

        {readiness.isPending && <div className="rowitem">Consultando as dependências…</div>}

        {readiness.isError && (
          <div className="rowitem">
            <div>
              <div className="n">API</div>
              <div className="d">sem resposta em /api/v1/ready</div>
            </div>
            <span className="badge err">FORA</span>
          </div>
        )}

        {dependencyNames.map((name) => {
          const check = checks[name];
          const isOk = check.status === "ok";
          return (
            <div className="rowitem" key={name}>
              <div>
                <div className="n">{DEPENDENCY_LABELS[name] ?? name}</div>
                <div className="d">
                  {isOk ? `${check.latency_ms} ms` : (check.error ?? "indisponível")}
                </div>
              </div>
              <span className={isOk ? "badge ok" : "badge err"}>{isOk ? "OK" : "FORA"}</span>
            </div>
          );
        })}

        {health.data && (
          <>
            <div className="sect">Versão</div>
            <div className="rowitem">
              <div className="n">API</div>
              <span className="d">{health.data.version}</span>
            </div>
          </>
        )}
      </div>

      <p className="muted">
        Etapa 1 de 8 concluída — esqueleto, infraestrutura e integração contínua.
        <br />
        Próxima: autenticação, multi-tenancy e Row Level Security.
      </p>
    </div>
  );
}
